import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CustomerDetail, CustomerManagementQuery, CustomerSummary} from "@/models";

export class CustomerService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAllCustomers(query: CustomerManagementQuery, cancelToken?: AbortSignal, isSilent?: boolean) {
        return this.baseApiFactory.getData<CustomerSummary[]>('/api/Customer', query, cancelToken, {silent: isSilent});
    }

    SelectCustomerDetail(id: number, langCode: string) {
        return this.baseApiFactory.getData<CustomerDetail>(`/api/Customer/${id}?langCode=${langCode}`);
    }

    InsertCustomer(value: any) {
        return this.baseApiFactory.post('/api/Customer', value);
    }

    UpdateCustomer(value: any) {
        return this.baseApiFactory.put('/api/Customer', value);
    }

    ChangeCustomerGroup(value: {
        Id: number,
        CustomerGroupId: number
    }) {
        return this.baseApiFactory.put('/api/Customer/ChangeCustomerGroup', value);
    }

    ChangeCustomerGroupByGroupId(
        oldCustomerGroupId: number,
        newCustomerGroupId: number
    ) {
        return this.baseApiFactory.put(`/api/Customer/ChangeCustomerGroupByGroup/${oldCustomerGroupId}`, {
            fromId: oldCustomerGroupId,
            toId: newCustomerGroupId
        });
    }

    DeleteCustomer(id: number) {
        return this.baseApiFactory.delete(`/api/Customer/${id}`);
    }

    ChangePassword(postData: any) {
        return this.baseApiFactory.post('/api/Customer/ChangePassword', postData);
    }

    ResetPassword(id: number) {
        return this.baseApiFactory.post('/api/Customer/ResetPassword', {customerId: id});
    }

    GetCSV(query: CustomerManagementQuery, fileName: string) {
        this.baseApiFactory.download(`/api/CustomerCsv?${query}`, {
            type: 'text/csv',
            fileName: fileName + new Date().toISOString().split('T')[0]
                .replaceAll('-', '') + ".csv"
        });
    }
}

lazyRegister.service('CustomerService', CustomerService);
